import { CheckCircleFilled, ClockCircleFilled } from "@ant-design/icons";
import { Tag } from "antd";
import React from "react";
import { colors } from "~/theme/colors.js";
import { Bevoegdheid } from "./Bevoegdheid.jsx";
import { DateFormat } from "~/components/date/DateFormat.jsx";
import { ParseMessage } from "../../atom/parseMessage.jsx";
import { $t } from "~/i18n.js";

export const Category = (
  key,
  category,
  user_id,
  cluster,
  setBevoegdheid,
  openBevoegdheid,
  latestAchievement
) => {
  // Check if this category is the latest achievement category
  const isLatestAchievementCategory = latestAchievement && 
    latestAchievement.category && 
    latestAchievement.category.id === category.id;

  return {
    key,
    label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>{category.label || category.name}</span>
          {isLatestAchievementCategory && (
            <Tag color="green">
              <DateFormat date={latestAchievement.date} />
            </Tag>
          )}
        </div>
    ),
    extra: (
        category.nearly_invalid ? (
          <ClockCircleFilled style={{ color: colors.orange }} />
        ) : category.count === category.bevoegdheid.length ? (
          <CheckCircleFilled style={{ color: colors.groen_dark }} />
        ) : (
          <p>
            {category.count}/{category.bevoegdheid.length}
          </p>
        )
    ),
    children: (
      <div className="column category">
        {category.description && (
          <div style={{ marginLeft: 10 }}>
            <ParseMessage className='small' message={category.description} />
          </div>
        )}

        {category.bevoegdheid.map((bevoegdheid, idx) => (
          <Bevoegdheid
            bevoegdheid={bevoegdheid}
            user_id={user_id}
            key={idx}
            cluster={cluster}
            setBevoegdheid={setBevoegdheid}
            openBevoegheid={openBevoegdheid}
            latestAchievement={latestAchievement}
          />
        ))}
      </div>
    ),
  };
};
